// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend-item {
  display: inline-block;
}
.legend-item .legend-item--icon {
  width: 20px;
  height: 20px;
  display: inline-block;
}
.legend-item .legend-item--text {
  top: -4px;
  position: relative;
}

.is-holiday {
  background-color: #1C5FAB !important;
  color: white !important;
}

.is-weekend {
  background-color: #b491c8 !important;
  color: white !important;
}

.wrapper-calendar--month table {
  width: 900px;
  table-layout: fixed;
}
.wrapper-calendar--month .calendar-element {
  border: 1px solid black;
  height: 100px;
  vertical-align: top;
  text-align: center;
  background-color: white;
}
.wrapper-calendar--month .calendar-element-day {
  cursor: pointer;
}
.wrapper-calendar--month .calendar-element-day:hover {
  opacity: 0.6;
}
.wrapper-calendar--month .calendar-wos-count-wrapper {
  display: flex;
  justify-content: center;
}
.wrapper-calendar--month .calendar-wos-count-wrapper .calendar-wos-count {
  padding: 13px 0;
  margin: 5px;
  height: 50px;
  width: 50px;
  border: 1px solid transparent;
  border-radius: 50px;
  color: white;
}
.wrapper-calendar--month .calendar-wos-count-wrapper .calendar-wos-count:hover {
  cursor: pointer;
  opacity: 0.7;
}
.wrapper-calendar--month .calendar-wos-count-wrapper .calendar-wos-count.scheduled {
  background-color: crimson;
}
.wrapper-calendar--month .calendar-wos-count-wrapper .calendar-wos-count.filtered {
  background-color: #5cb85c;
}

.month-count-color--scheduled {
  background-color: crimson;
}

.month-count-color--filtered {
  background-color: #5cb85c;
}

.wrapper-calendar {
  margin-top: 10px;
}

.queue-title {
  padding: 3px 0;
  text-align: center;
  font-weight: bold;
  text-decoration: underline;
  text-transform: uppercase;
  font-weight: 1.2rem;
}

.queue-list {
  /*border: 1px solid #ccc;*/
  /*padding: 2px;*/
  min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
}

.queue-item {
  cursor: move;
  box-sizing: border-box;
  /*padding: 8px 0 10px 8px;*/
  border: 1px solid #ccc;
  margin-bottom: 2px;
  position: relative;
  height: 40px;
  padding: 2px 0 10px 8px;
  background: linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(238, 238, 238));
}

.queue-item::after {
  content: "";
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  width: 4px;
  /*background-color: #666;*/
  background-color: #1066a8;
}

.queue button {
  display: block;
  width: 100%;
  margin-bottom: 5px;
  /*background-color: #f3f3f3;*/
  background-color: #3c78d8;
  color: white;
  /*border: 1px solid #ccc;*/
  border: 0;
  padding: 0.5rem 1rem;
  font-size: 14px;
  cursor: pointer;
}

:host ::ng-deep .custom-calender button.p-datepicker-trigger {
  background: white;
}

::ng-deep button.modal_default_cancel {
  display: none;
}

/* Calendar & Table Shimmer / Skeleton Loader */
@keyframes shimmerGleam {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
.shimmer-animated,
::ng-deep .shimmer-animated {
  position: relative;
  overflow: hidden;
  background-color: #e2e8f0;
  border-radius: 4px;
}
.shimmer-animated::after,
::ng-deep .shimmer-animated::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.45) 25%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.45) 75%, rgba(255, 255, 255, 0) 100%);
  animation: shimmerGleam 1.4s infinite cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
}

::ng-deep .shimmer-table-row {
  height: 48px;
}
::ng-deep .shimmer-table-row td {
  vertical-align: middle !important;
  padding: 0.75rem 1rem !important;
  border-top: 1px solid #ebedf2;
}
::ng-deep .shimmer-table-row .shimmer-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 3px;
  margin: 0 auto;
}
::ng-deep .shimmer-table-row .shimmer-table-cell {
  height: 14px;
  border-radius: 3px;
}

.calendar-shimmer-container {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #ffffff;
  padding: 12px;
  margin-top: 10px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.calendar-shimmer-container .shimmer-header {
  display: flex;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}
.calendar-shimmer-container .shimmer-header .shimmer-col-engineer {
  width: 220px;
  height: 36px;
  flex-shrink: 0;
}
.calendar-shimmer-container .shimmer-header .shimmer-col-slots {
  display: flex;
  gap: 8px;
  flex-grow: 1;
  overflow: hidden;
}
.calendar-shimmer-container .shimmer-header .shimmer-col-slots .shimmer-slot {
  flex: 1;
  height: 36px;
  min-width: 60px;
}
.calendar-shimmer-container .shimmer-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 12px;
}
.calendar-shimmer-container .shimmer-body .shimmer-row {
  display: flex;
  gap: 10px;
  align-items: center;
}
.calendar-shimmer-container .shimmer-body .shimmer-row .shimmer-engineer-card {
  width: 220px;
  height: 48px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  padding: 0 8px;
  background: #f8fafc;
  border-radius: 4px;
}
.calendar-shimmer-container .shimmer-body .shimmer-row .shimmer-engineer-card .shimmer-line-name {
  height: 14px;
  width: 80%;
}
.calendar-shimmer-container .shimmer-body .shimmer-row .shimmer-engineer-card .shimmer-line-sub {
  height: 10px;
  width: 45%;
}
.calendar-shimmer-container .shimmer-body .shimmer-row .shimmer-events-area {
  display: flex;
  gap: 8px;
  flex-grow: 1;
  height: 48px;
  align-items: center;
  background: #f8fafc;
  border-radius: 4px;
  padding: 0 10px;
}
.calendar-shimmer-container .shimmer-body .shimmer-row .shimmer-events-area .shimmer-event-bar {
  height: 32px;
  border-radius: 4px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
